import { ReactNode } from "react";

export enum MenuTypes {
    RESOURCES = "Resources",
    DOCUMENTS = "Documents",
    ACCELERATE = "Accelerate",
}

export interface MenuOption {
    label: string;
    to: string;
    icon: ReactNode;
    shortLabel: string;
    key: number;
    pattern?: string; // Optional pattern for route matching
    configParameter?: string; // Config flag gating visibility of this option
}

export interface ExpandableMenuOptionsProps {
    isOpen: boolean;
    icon: ReactNode;
    isSelected?: boolean;
    title: string;
    options?: MenuOption[]; // Optional - will auto-generate based on title if not provided
    className?: string;
    onClick?: (currentLocationTitle: string) => void;
}
